<template>
    <div class="position-relative h-100">
        <main class="budget budget-creation">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-8">
                        <div class="wizard">
                            <div class="wizard-header">
                                <h3>{{ $t('Создание бюджета') }}</h3>
                            </div>
                            <div class="wizard-container">
                                <p>Для создания бюджета укажите название, и счета которые будут учитыватся при рассчетах данного бюджета.</p>
                                <p>После создания бюджета вы сможете настроить его, индивидуально указав данные на каждый месяц.</p>

                                <div class="form-group">
                                    <input type="text" :class="{'form-control': true, 'is-invalid': hasError('name')}" v-model="form.name" placeholder="Название">

                                    <span class="invalid-feedback">{{ getError('name') }}</span>
                                </div>
                                
                                <div class="form-group">
                                    <multiselect v-model="form.accounts" :multiple="true" :options="accounts" :placeholder="$t('Счета')" :custom-label="nameWithBalance" label="title" track-by="id"></multiselect>

                                    <span class="invalid-feedback">{{ getError('accounts') }}</span>
                                </div>

                                <div class="alert alert-info">
                                    Оставьте список счетов пустым, если хотите взять в учет этого бюджета все существующие счета.
                                </div>

                                <div class="text-center">
                                    <button class="btn btn-success" @click="store">Создать</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import "../../components/Budget/style.scss";
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
    name: "BudgetCreate",

    data: function() {
        return {
            form: {
                name: null,
                accounts: [],
            },

            errors: {},
        };
    },

    mounted() {
        this.loadAccounts();
    },

    watch: {
        'form.name': function() {
            delete this.errors['name'];
        },
        'form.accounts': function() {
            delete this.errors['accounts'];
        },
    },

    computed: {
        ...mapGetters(['accounts']),
    },

    methods: {
        ...mapActions(['loadAccounts']),
        
        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);

            return `${title} — ${balance} ${currency}`;
        },

        store() {
            this.$ga.event('budgetCreate', 'clicked');

            axios.post('/budget/create', this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message ? data.message : $t('Бюджет создан'), 'success');

                    this.$ga.event('budgetCreate', 'created');

                    this.$router.push(`/budget/${data.data.id}`);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
}
</script>

<style lang="scss">
.wizard {
    margin-top: 20px;
    
    .wizard-header {
        h3 {
            font-size: 23px;
        }

        margin-bottom: 15px;
    }

    .wizard-container {
        padding: 10px 15px;
        background: #fff;
        box-shadow: 0 4px 8px 0 rgba(48, 82, 120, .08);
        border-radius: 3px;

        p {
            font-size: 14px;
        }
    }
}

.budget-creation {
    .wizard-container {
        padding: 15px!important;
    }
}
</style>